import { textVariant } from './Text'
import { createStyles } from '@codeleap/styles'
import { StyleRegistry } from '../styles'

export type LinkComposition = 'anchor' | 'text'

const createLinkVariant = createStyles<LinkComposition>

export const LinkStyles = {
  default: createLinkVariant(theme => ({
    anchor: {
      ...textVariant('p3'),
      textDecoration: 'underline',
    },
  })),
  'noUnderline': createLinkVariant(theme => ({
    anchor: {
      textDecoration: 'none',
    },
  })),
}

StyleRegistry.registerVariants('Link', LinkStyles)
